export default __webpack_public_path__ + "static/media/abundancesystems.ab3e62a4.jpg";